import React from "react";
import { Notifier } from "../../../ecosystem";

export const CareGapsError = (props) => {
   
    return (
        <div className="row care-gaps-error-container">
            <div className="col-12">
                <Notifier
                    colorStyle="error"
                    icon="exclamation"
                    heading="Something went wrong"
                >
                    We were unable to complete your update. Would you like to try again?
                </Notifier>
            </div>
        </div>
    );
};